
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aktuellt/[postId]",
      function () {
        return require("private-next-pages/aktuellt/[postId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aktuellt/[postId]"])
      });
    }
  